import { createBrowserHistory, createLocation } from 'history';
export const history = createBrowserHistory();
export const location = createLocation();